import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    height: 20,
  },
})(LinearProgress);
